import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Store } from 'lucide-react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import Table from '../../components/ui/Table';
import Modal from '../../components/ui/Modal';
import Input from '../../components/ui/Input';
import { useToast } from '../../components/ui/Toast';
import { stores } from '../../data/mockData';

export default function StoreList() {
  const navigate = useNavigate();
  const toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ code: '', name: '', address: '' });

  const columns = [
    { key: 'code', label: 'Код', render: v => <code style={{ background: '#F3F4F6', padding: '2px 8px', borderRadius: 6, fontSize: 12, fontWeight: 700, color: '#4A6CF7' }}>{v}</code> },
    { key: 'name', label: 'Название', render: v => <span style={{ fontWeight: 600 }}>{v}</span> },
    { key: 'address', label: 'Адрес', render: v => <span style={{ color: '#6B7280', fontSize: 12 }}>{v}</span> },
    { key: 'employeeCount', label: 'Сотрудников', render: v => <Badge variant="primary">{v} чел.</Badge> },
    { key: 'activeTasks', label: 'Активных задач', render: v => <Badge variant={v > 10 ? 'warning' : 'gray'}>{v}</Badge> },
    { key: 'productCount', label: 'Товаров', render: v => <span style={{ fontWeight: 600 }}>{v}</span> },
    {
      key: 'actions', label: '', sortable: false,
      render: (_, row) => (
        <div style={{ display: 'flex', gap: 6 }} onClick={e => e.stopPropagation()}>
          <button onClick={() => toast('Магазин отредактирован', 'success')} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #E5E7EB', background: '#fff', cursor: 'pointer', color: '#6B7280' }}>Редакт.</button>
          <button onClick={() => toast('Магазин деактивирован', 'warning')} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #F0F0F0', background: '#fff', cursor: 'pointer', color: '#FF3B30' }}>Деакт.</button>
        </div>
      )
    }
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1A2E' }}>Магазины</h1>
          <p style={{ color: '#8E8E93', fontSize: 13, marginTop: 2 }}>Всего: {stores.length} магазинов</p>
        </div>
        <Button icon={<Plus size={15} />} onClick={() => setShowModal(true)}>Добавить магазин</Button>
      </div>

      {/* Store cards grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
        {stores.map(s => (
          <div key={s.id} onClick={() => navigate(`/stores/${s.id}`)} style={{
            background: '#fff', borderRadius: 14, padding: 20, border: '1px solid #F0F0F0',
            cursor: 'pointer', transition: 'all 0.15s',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(74,108,247,0.15)'; e.currentTarget.style.borderColor = '#4A6CF7'; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)'; e.currentTarget.style.borderColor = '#F0F0F0'; }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <div style={{ width: 44, height: 44, borderRadius: 12, background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Store size={20} color="#4A6CF7" />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#1A1A2E' }}>{s.name}</div>
                <div style={{ fontSize: 12, color: '#8E8E93', marginTop: 2 }}>{s.address}</div>
                <code style={{ fontSize: 11, color: '#4A6CF7', background: '#EEF2FF', padding: '1px 6px', borderRadius: 4, marginTop: 4, display: 'inline-block' }}>{s.code}</code>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 16, marginTop: 16, paddingTop: 14, borderTop: '1px solid #F3F4F6' }}>
              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#4A6CF7' }}>{s.employeeCount}</div>
                <div style={{ fontSize: 11, color: '#8E8E93' }}>Сотрудников</div>
              </div>
              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: s.activeTasks > 10 ? '#FF9500' : '#34C759' }}>{s.activeTasks}</div>
                <div style={{ fontSize: 11, color: '#8E8E93' }}>Задач</div>
              </div>
              <div style={{ textAlign: 'center', flex: 1 }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#1A1A2E' }}>{s.productCount}</div>
                <div style={{ fontSize: 11, color: '#8E8E93' }}>Товаров</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Card padding="0" title="Список магазинов">
        <Table columns={columns} data={stores} onRowClick={row => navigate(`/stores/${row.id}`)} />
      </Card>

      <Modal open={showModal} onClose={() => setShowModal(false)} title="Добавить магазин">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Input label="Код магазина" value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} placeholder="OSG-006" required />
          <Input label="Название" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Магазин Алмазар" required />
          <Input label="Адрес" value={form.address} onChange={e => setForm(f => ({ ...f, address: e.target.value }))} placeholder="ул. Примерная, 1, Ташкент" required />
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 8 }}>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Отмена</Button>
            <Button onClick={() => { toast('Магазин создан', 'success'); setShowModal(false); }}>Создать</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
